import './App.css';
import { Typography, Button } from '@mui/material';
import Navbar from './components/Navbar';
import Theme from './components/Theme';
import Home from './pages/Home';
import {
  Link,
  Route,
  Routes,
} from "react-router-dom";
import GetStarted from './components/GetStarted';
import Buy from './pages/Buy';
import Footer from './components/Footer';
import { Sell } from './pages/Sell';
import Contactus from './pages/Contactus';

function App() {
  return (
    <div className='body'>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Buy" element={<Buy />} />
        <Route path="/Sell" element={<Sell />}/>
        <Route path="/Contact-US" element={<Contactus />}/>
        <Route path="/Questions" element={<GetStarted />} />
        <Route path="/Questions/Selling-a-Home" element={<GetStarted />} />
      </Routes>
      <div><Footer /></div>
    </div>
  );
}

export default App;
